<template>
  <v-row justify="center" v-if="modal_scrap">
    <v-dialog v-model="dialog" persistent max-width="1000px" scrollable>
      <v-form enctype="multipart/form-data" ref="form" v-model="valid">
        <v-card class="rounded-lg elevation-4">
          <!-- Header Toolbar -->
          <v-toolbar height="60" color="secondary" dark flat class="px-3">
            <v-icon left>mdi-tire</v-icon>
            <span class="text-h6 font-weight-medium">
              {{ Titulo || "Editar neumático en Scrap" }}
            </span>
            <v-chip
              v-if="Item && Item.num_serie"
              color="white"
              text-color="secondary"
              class="font-weight-bold ml-3 px-3 elevation-1"
              style="font-size: 1.05rem; height: 36px"
            >
              <v-icon left size="20" color="secondary">mdi-barcode-scan</v-icon>
              Serie: {{ Item.num_serie }}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              @click="cerrarDialogo()"
              title="Cerrar"
              :disabled="guardando"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <!-- Card Content -->
          <v-card-text class="pa-5" style="max-height: 80vh">
            <!-- Sección: Datos del Retiro -->
            <div class="mb-4">
              <div class="d-flex align-center mb-3">
                <v-icon small color="primary" class="mr-2"
                  >mdi-clipboard-text-outline</v-icon
                >
                <span class="text-subtitle-1 font-weight-bold text--primary"
                  >Datos del Retiro / Scrap</span
                >
              </div>

              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    label="Remanente final"
                    v-model="Item.remanente_final"
                    outlined
                    dense
                    suffix="mm"
                    prepend-inner-icon="mdi-ruler"
                    hide-details="auto"
                    type="number"
                    step="0.1"
                    min="0"
                    :rules="[
                      (v) =>
                        (v !== null && v !== undefined && v !== '') ||
                        'Remanente final es requerido',
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    type="date"
                    label="Fecha RETIRO/SCRAP"
                    v-model="Item.fecha"
                    outlined
                    dense
                    prepend-inner-icon="mdi-calendar"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Fecha es requerida']"
                    required
                  ></v-text-field>
                </v-col>

                <v-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="MotivosScrap && MotivosScrap.length > 0"
                >
                  <v-autocomplete
                    :items="MotivosScrap"
                    v-model="Item.id_motivo_scrap"
                    label="Motivo SCRAP"
                    outlined
                    dense
                    prepend-inner-icon="mdi-alert-octagon-outline"
                    hide-details="auto"
                    :rules="[(v) => !!v || 'Motivo scrap es requerido']"
                  ></v-autocomplete>
                </v-col>

                <!-- Textarea Recomendación -->
                <v-col cols="12" class="mt-2">
                  <v-textarea
                    label="Recomendación"
                    v-model="Item.recomendacion"
                    outlined
                    dense
                    rows="3"
                    auto-grow
                    counter="500"
                    maxlength="500"
                    clearable
                    prepend-inner-icon="mdi-comment-text-outline"
                    placeholder="Ingrese recomendaciones u observaciones técnicas sobre este neumático en scrap..."
                    hide-details="auto"
                  ></v-textarea>
                </v-col>
              </v-row>
            </div>

            <v-divider class="my-4"></v-divider>

            <!-- Sección: Evidencias Fotográficas (3 Imágenes) -->
            <div>
              <div class="d-flex align-center justify-space-between mb-3">
                <div class="d-flex align-center">
                  <v-icon small color="primary" class="mr-2"
                    >mdi-camera-burst</v-icon
                  >
                  <span class="text-subtitle-1 font-weight-bold text--primary"
                    >Evidencias Fotográficas</span
                  >
                </div>
                <span
                  class="text-caption grey--text text--darken-1 font-weight-medium"
                >
                  Seleccione las imágenes; se subirán al presionar Guardar
                </span>
              </div>

              <v-row dense>
                <!-- IMAGEN 1 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 1</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="
                          previewLocal1
                            ? 'info'
                            : Item.neumaticoimgruta1
                            ? 'success'
                            : 'grey lighten-2'
                        "
                        :text-color="
                          previewLocal1 || Item.neumaticoimgruta1
                            ? 'white'
                            : 'grey darken-2'
                        "
                      >
                        {{
                          previewLocal1
                            ? "Por guardar"
                            : Item.neumaticoimgruta1
                            ? "Disponible"
                            : "Sin imagen"
                        }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent1"
                      :autoUpload="false"
                      @archivosubido="archivosubido1"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal1">
                        <img
                          :src="previewLocal1"
                          alt="Nueva Foto 1"
                          class="preview-img"
                        />
                      </template>
                      <template v-else-if="Item.neumaticoimgruta1 != null">
                        <img
                          :src="ruta + Item.neumaticoimgruta1"
                          alt="Neumatico 1"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- IMAGEN 2 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 2</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="
                          previewLocal2
                            ? 'info'
                            : Item.neumaticoimgruta2
                            ? 'success'
                            : 'grey lighten-2'
                        "
                        :text-color="
                          previewLocal2 || Item.neumaticoimgruta2
                            ? 'white'
                            : 'grey darken-2'
                        "
                      >
                        {{
                          previewLocal2
                            ? "Por guardar"
                            : Item.neumaticoimgruta2
                            ? "Disponible"
                            : "Sin imagen"
                        }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent2"
                      :autoUpload="false"
                      @archivosubido="archivosubido2"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal2">
                        <img
                          :src="previewLocal2"
                          alt="Nueva Foto 2"
                          class="preview-img"
                        />
                      </template>
                      <template v-else-if="Item.neumaticoimgruta2 != null">
                        <img
                          :src="ruta + Item.neumaticoimgruta2"
                          alt="Neumatico 2"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>

                <!-- IMAGEN 3 -->
                <v-col cols="12" sm="6" md="4">
                  <v-card
                    outlined
                    class="pa-3 rounded-lg fill-height d-flex flex-column photo-card"
                  >
                    <div class="d-flex align-center justify-space-between mb-2">
                      <div class="d-flex align-center">
                        <v-icon small color="primary" class="mr-1"
                          >mdi-camera</v-icon
                        >
                        <span class="font-weight-bold text-caption"
                          >IMAGEN 3</span
                        >
                      </div>
                      <v-chip
                        x-small
                        :color="
                          previewLocal3
                            ? 'info'
                            : Item.neumaticoimgruta3
                            ? 'success'
                            : 'grey lighten-2'
                        "
                        :text-color="
                          previewLocal3 || Item.neumaticoimgruta3
                            ? 'white'
                            : 'grey darken-2'
                        "
                      >
                        {{
                          previewLocal3
                            ? "Por guardar"
                            : Item.neumaticoimgruta3
                            ? "Disponible"
                            : "Sin imagen"
                        }}
                      </v-chip>
                    </div>

                    <FileAgent
                      ref="fileAgent3"
                      :autoUpload="false"
                      @archivosubido="archivosubido3"
                      style="z-index: 0"
                    />

                    <div
                      class="preview-box mt-3 flex-grow-1 d-flex align-center justify-center"
                    >
                      <template v-if="previewLocal3">
                        <img
                          :src="previewLocal3"
                          alt="Nueva Foto 3"
                          class="preview-img"
                        />
                      </template>
                      <template v-else-if="Item.neumaticoimgruta3 != null">
                        <img
                          :src="ruta + Item.neumaticoimgruta3"
                          alt="Neumatico 3"
                          class="preview-img"
                        />
                      </template>
                      <div v-else class="empty-state">
                        <v-icon large color="grey lighten-1"
                          >mdi-image-off-outline</v-icon
                        >
                        <span
                          class="text-caption grey--text text--darken-1 mt-1"
                          >Imagen no disponible</span
                        >
                      </div>
                    </div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>

          <!-- Footer Actions -->
          <v-card-actions class="pa-4 bg-actions">
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-2"
              text
              class="px-4 text-capitalize font-weight-bold"
              @click="cerrarDialogo()"
              :disabled="guardando"
            >
              <v-icon left small>mdi-close</v-icon>
              Cerrar
            </v-btn>
            <v-btn
              :disabled="!valid || guardando"
              :loading="guardando"
              color="info"
              class="px-6 text-capitalize font-weight-bold elevation-1"
              @click="agregar()"
            >
              <v-icon left small>mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { axios2 as axios } from "@/interceptor/useApi";
import global from "../../global";
import FileAgent from "../FileAgent.vue";
import { mapActions } from "vuex";

export default {
  props: ["Titulo", "dialog", "Item", "MotivosScrap"],
  components: { FileAgent },
  data() {
    return {
      modal_scrap: true,
      ruta: "",
      valid: false,
      guardando: false,
      nuevaFoto1: null,
      nuevaFoto2: null,
      nuevaFoto3: null,
      previewLocal1: null,
      previewLocal2: null,
      previewLocal3: null,
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.limpiarArchivosLocales();
        if (this.Item) {
          if (this.Item.recomendacion === undefined) {
            this.$set(this.Item, "recomendacion", "");
          }
        }
      }
    },
  },
  methods: {
    ...mapActions("scrap", ["cargarNeumaticosScrap"]),

    limpiarArchivosLocales() {
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      this.nuevaFoto1 = null;
      this.nuevaFoto2 = null;
      this.nuevaFoto3 = null;
      this.previewLocal1 = null;
      this.previewLocal2 = null;
      this.previewLocal3 = null;
      if (this.$refs.fileAgent1) this.$refs.fileAgent1.reset();
      if (this.$refs.fileAgent2) this.$refs.fileAgent2.reset();
      if (this.$refs.fileAgent3) this.$refs.fileAgent3.reset();
    },

    archivosubido1: function ({ valor, fileRecords }) {
      this.nuevaFoto1 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal1) URL.revokeObjectURL(this.previewLocal1);
      if (this.nuevaFoto1 && this.nuevaFoto1[0] && this.nuevaFoto1[0].file) {
        this.previewLocal1 = URL.createObjectURL(this.nuevaFoto1[0].file);
      } else {
        this.previewLocal1 = null;
      }
    },

    archivosubido2: function ({ valor, fileRecords }) {
      this.nuevaFoto2 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal2) URL.revokeObjectURL(this.previewLocal2);
      if (this.nuevaFoto2 && this.nuevaFoto2[0] && this.nuevaFoto2[0].file) {
        this.previewLocal2 = URL.createObjectURL(this.nuevaFoto2[0].file);
      } else {
        this.previewLocal2 = null;
      }
    },

    archivosubido3: function ({ valor, fileRecords }) {
      this.nuevaFoto3 =
        fileRecords && fileRecords.length > 0 ? fileRecords : null;
      if (this.previewLocal3) URL.revokeObjectURL(this.previewLocal3);
      if (this.nuevaFoto3 && this.nuevaFoto3[0] && this.nuevaFoto3[0].file) {
        this.previewLocal3 = URL.createObjectURL(this.nuevaFoto3[0].file);
      } else {
        this.previewLocal3 = null;
      }
    },

    cerrarDialogo() {
      this.limpiarArchivosLocales();
      this.modal_scrap = false;
      this.$nextTick().then(() => {
        this.modal_scrap = true;
      });
      this.$emit("dialog", false);
    },

    async subirFoto(file) {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axios.post("imagen/subirimagen", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return typeof res.data === "string"
        ? res.data
        : res.data?.data || res.data?.nombre || "";
    },

    async agregar() {
      try {
        if (this.$refs.form && !this.$refs.form.validate()) {
          return;
        }
        this.guardando = true;

        // 1. Subir Foto 1 si el usuario seleccionó un nuevo archivo
        if (
          this.nuevaFoto1 &&
          this.nuevaFoto1.length > 0 &&
          this.nuevaFoto1[0].file
        ) {
          const nombre1 = await this.subirFoto(this.nuevaFoto1[0].file);
          if (nombre1) {
            this.Item.ruta1 = [{ upload: { data: nombre1 } }];
            this.Item.neumaticoimg1 = nombre1;
            this.Item.neumaticoimgruta1 =
              "images/reportes/img_neumaticos_mal_estado/" + nombre1;
          }
        }

        // 2. Subir Foto 2 si el usuario seleccionó un nuevo archivo
        if (
          this.nuevaFoto2 &&
          this.nuevaFoto2.length > 0 &&
          this.nuevaFoto2[0].file
        ) {
          const nombre2 = await this.subirFoto(this.nuevaFoto2[0].file);
          if (nombre2) {
            this.Item.ruta2 = [{ upload: { data: nombre2 } }];
            this.Item.neumaticoimg2 = nombre2;
            this.Item.neumaticoimgruta2 =
              "images/reportes/img_neumaticos_mal_estado/" + nombre2;
          }
        }

        // 3. Subir Foto 3 si el usuario seleccionó un nuevo archivo
        if (
          this.nuevaFoto3 &&
          this.nuevaFoto3.length > 0 &&
          this.nuevaFoto3[0].file
        ) {
          const nombre3 = await this.subirFoto(this.nuevaFoto3[0].file);
          if (nombre3) {
            this.Item.ruta3 = [{ upload: { data: nombre3 } }];
            this.Item.neumaticoimg3 = nombre3;
            this.Item.neumaticoimgruta3 =
              "images/reportes/img_neumaticos_mal_estado/" + nombre3;
          }
        }

        // 4. Guardar datos en scrap/update
        const url = "scrap/update";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
          id_usuario: localStorage.getItem("id"),
          neumatico: this.Item,
        };
        const response = await axios.post(url, data);
        if (response?.status == 200 || response?.data) {
          this.$emit("dialog", false);
          this.$alertify.success("Neumático editado satisfactoriamente");
          this.limpiarArchivosLocales();

          // Refrescar las listas de forma asíncrona sin recargar la página
          try {
            if (this.cargarNeumaticosScrap) {
              await this.cargarNeumaticosScrap();
            }
          } catch (e) {
            console.warn("No se pudo recargar scrap store:", e);
          }
          this.$emit("itemActualizado", this.Item);
        }
      } catch (error) {
        console.error("error!", error);
        this.errorMessage = error.response
          ? error.response.data
          : error.message;
        this.$alertify.error("Error al actualizar el neumático en scrap");
      } finally {
        this.guardando = false;
      }
    },
  },
  mounted() {
    this.ruta = global.ruta_image;
  },
  beforeDestroy() {
    this.limpiarArchivosLocales();
  },
};
</script>

<style scoped>
.photo-card {
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
  transition: all 0.2s ease-in-out;
}
.photo-card:hover {
  border-color: #94a3b8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}
.preview-box {
  min-height: 200px;
  background-color: #ffffff;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
  overflow: hidden;
  padding: 6px;
}
.preview-img {
  width: 100%;
  max-height: 210px;
  object-fit: contain;
  border-radius: 6px;
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
}
.bg-actions {
  background-color: #f8fafc;
}
</style>
